module.exports = __webpack_public_path__ + "img/iraq.823085bc.svg";